import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';

import StorageControl, { slotKeys } from './StorageControl';

interface AlertProps {
    onClose: (() => void),
    onClickSave: ((title: string) => void),
    defaultTitle: string,
    message: string,
}

function YubinukiStorageSaveOption(props: AlertProps) {
    const [title, setTitle] = useState(props.defaultTitle);
    return (
        <div className="react-confirm-alert customAlert">
            <div className="alertBody">
                <h1>保存の確認</h1>
                {props.message}
                <div className="form-group">
                    <label htmlFor="titleForSave">タイトルまたはメモ：</label>
                    <input type="text" id="titleForSave" name="titleForSave" className="form-control" placeholder="タイトルまたはメモを入力する" value={title} onChange={(e) => {setTitle(e.currentTarget.value)}}/>
                </div>
                <div className="buttonGroup">
                    <button className="btn" onClick={props.onClose}>キャンセル</button>
                    <button className="btn btn-secondary" onClick={() => {
                        props.onClickSave(title);
                        props.onClose();
                    }}>保存する</button>
                </div>
            </div>
        </div>
    )
}

interface Props {
    slotKey: string | undefined,
    onClickLoad: ((slotKey: string) => void),
    onClickSave: ((slotKey: string, title: string) => void),
};

function YubinukiStorageControl(props: Props) {
    let defaultSlot: string
    if (props.slotKey === undefined) {
        defaultSlot = slotKeys[0];
    } else {
        defaultSlot = props.slotKey;
    }
    const [selectedSlot, setSelectedSlot] = useState(defaultSlot);

    function handleLoad() {
        let slotKey = selectedSlot;
        if (slotKey) {
            props.onClickLoad(slotKey);
        }
    }
    function handleConfirmedSave(title: string) {
        let slotKey = selectedSlot;
        props.onClickSave(slotKey, title);
    }
    function handleSave() {
        let slotKey = selectedSlot;
        var slotSavedTitle: string = '';
        let slotData = StorageControl.load(slotKey);
        if (slotData) {
            slotSavedTitle = slotData.title;
        }
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <YubinukiStorageSaveOption defaultTitle={slotSavedTitle} message={`'${slotKey.substr(4)}' に保存します。`} onClose={onClose} onClickSave={handleConfirmedSave} />
                )
            }
        })
    }

    let storageOptions = StorageControl.list().map((info, index) => {
        return <option value={info.key} key={info.key}>{info.key === props.slotKey ? "★ 》" : ""}{`0${index + 1}`} - {info.hasData ? info.title : "(NO DATA)"}</option>
    });

    var dataStateLabel = ""
    if (props.slotKey === undefined) {
        dataStateLabel = "このデータは保存されていません。"
    } else {
        dataStateLabel = `このデータは '${props.slotKey.substr(4)}' から読み込まれました。`
    }

    return (
        <div className="storageControl">
            <form>
                <div className="row"><div className="col">
                    {dataStateLabel}
                </div></div>
                <div className="row">
                    <div className="col-sm">
                        <select id='slotKey' value={selectedSlot} className="form-control" onChange={(e) => { setSelectedSlot(e.currentTarget.value) }}>
                            {storageOptions}
                        </select>
                    </div>
                    <div className="col-sm">
                        <button type="button" name="load" className="btn btn-outline-secondary mr-2" onClick={handleLoad}>
                            読み込む
                        </button>
                        <button type="button" name="save" className="btn btn-outline-secondary" onClick={handleSave}>
                            保存する
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default YubinukiStorageControl;
